try {
(function(){
  var product = 'both';
  var symptom = null;
  var LABELS = {"pairing": "Won't pair", "syncing": "Stopped syncing", "missing": "Missing data", "battery": "Battery or charging", "time": "Timestamps look wrong", "export": "Exports & data fields", "orders": "Orders, delivery & warranty", "docs": "Calibration & documentation"};
  var CATEGORY = {pairing:'Pairing', syncing:'Syncing', missing:'Missing data', battery:'Battery', time:'Timestamps', export:'Export', orders:'Orders & delivery', docs:'Documentation'};
  var SYN = {connect:'pair', connecting:'pair', pairing:'pair', bluetooth:'pair', upload:'sync', syncing:'sync', synchron:'sync', lost:'missing', gone:'missing', charge:'battery', charging:'battery', power:'battery', clock:'time', timestamp:'time', csv:'export', download:'export', shipping:'delivery', customs:'duties', broken:'damaged', certificate:'calibration', waterproof:'water'};

  // product toggle
  var toggles = document.querySelectorAll('.product-toggle button');
  toggles.forEach(function(b){ b.addEventListener('click', function(){
    toggles.forEach(function(x){ x.classList.remove('active'); }); b.classList.add('active');
    product = b.getAttribute('data-product'); filterFaq();
    var sel = document.getElementById('sModel'); if (product === 'v1' || product === 'pro') sel.value = product === 'v1' ? 'Button V1' : 'Button PRO';
    updateSummary();
  }); });

  // symptom tiles → checklist
  var tiles = document.querySelectorAll('.symptom');
  var guided = document.getElementById('guided');
  tiles.forEach(function(t){ t.addEventListener('click', function(){
    tiles.forEach(function(x){ x.classList.remove('active'); }); t.classList.add('active');
    symptom = t.getAttribute('data-symptom');
    document.querySelectorAll('.checklist').forEach(function(c){ c.hidden = c.getAttribute('data-symptom') !== symptom; });
    guided.hidden = false; document.getElementById('solvedThanks').hidden = true;
    document.getElementById('sCategory').value = CATEGORY[symptom];
    updateSummary(); filterFaq();
    var tri = document.querySelector('#triage .section-head'); window.scrollTo({top: tri.getBoundingClientRect().top + window.scrollY - 88, behavior:'smooth'});
  }); });
  document.querySelectorAll('[data-check]').forEach(function(cb){ cb.addEventListener('change', updateSummary); });

  // solved?
  document.getElementById('solvedYes').addEventListener('click', function(){
    document.getElementById('solvedThanks').hidden = false;
    document.getElementById('request').hidden = true;
    // analytics hook: window.dataLayer && dataLayer.push({event:'support_solved', symptom:symptom, product:product});
  });
  function openRequest(){
    document.getElementById('request').hidden = false; document.getElementById('ack').hidden = true;
    document.getElementById('supportForm').classList.remove('hidden');
    document.querySelector('.request-intro').style.display = '';
    updateSummary();
    document.getElementById('request').scrollIntoView({behavior:'smooth', block:'start'});
  }
  document.getElementById('solvedNo').addEventListener('click', openRequest);
  document.getElementById('openRequestBtn').addEventListener('click', openRequest);
  document.getElementById('faqEmptyAsk').addEventListener('click', function(e){ e.preventDefault(); openRequest(); });

  // live summary (becomes the ticket name in HubSpot)
  function val(id){ var el = document.getElementById(id); return el ? (el.value || '').trim() : ''; }
  function subjectLine(){
    var cat = val('sCategory') || (symptom ? CATEGORY[symptom] : 'Support');
    var model = val('sModel') || ({v1:'Button V1', pro:'Button PRO'}[product] || 'Button');
    var n = parseInt(val('sCount'), 10) || 1; var ids = n + (n === 1 ? ' Button' : ' Buttons');
    var proj = val('sProject') || 'No project name';
    return cat + ' issue | ' + model + ' | ' + ids + ' | ' + proj;
  }
  function checklistText(){
    if (!symptom) return 'No checklist selected';
    var checked = [];
    var cl = document.querySelector('.checklist[data-symptom="' + symptom + '"]');
    if (cl) cl.querySelectorAll('[data-check]').forEach(function(cb, i){ if (cb.checked) checked.push('step ' + (i+1)); });
    return 'Checklist “' + LABELS[symptom] + '” · confirmed: ' + (checked.length ? checked.join(', ') : 'none yet') + ' · FAQ reviewed: yes';
  }
  function updateSummary(){
    document.getElementById('summarySubject').textContent = subjectLine();
    document.getElementById('summaryChecks').textContent = symptom
      ? checklistText()
      : 'No checklist selected. Pick a symptom above so we can include what you already tried.';
  }
  ['sCategory','sModel','sCount','sProject'].forEach(function(id){ document.getElementById(id).addEventListener('input', updateSummary); document.getElementById(id).addEventListener('change', updateSummary); });

  // submit → HubSpot "Support form" (contact + ticket)
  var supportForm = document.getElementById('supportForm');
  var errEl = document.getElementById('supportError');
  var submitBtn = supportForm.querySelector('.gate-submit');
  supportForm.addEventListener('submit', function(e){
    e.preventDefault();
    var form = e.target; var missing = [];
    form.querySelectorAll('[required]').forEach(function(f){
      var bad = !f.value.trim() || (f.type === 'email' && !f.checkValidity());
      if (bad){
        missing.push(f);
        f.style.outline = '2px solid #c0392b';
        f.addEventListener('input', function(){ f.style.outline = ''; }, { once: true });
        f.addEventListener('change', function(){ f.style.outline = ''; }, { once: true });
      }
    });
    // missing or invalid required fields: say so, and jump to the first one
    if (missing.length){
      // DRAFT copy (Heidi to approve)
      errEl.textContent = 'Please fill in the highlighted fields (' + missing.length + ').';
      errEl.hidden = false;
      missing[0].scrollIntoView({behavior:'smooth', block:'center'}); missing[0].focus({preventScroll:true});
      if (window.LYS_HS) LYS_HS.debug('support: not sent, required fields missing or invalid: ' + missing.map(function(f){ return f.id; }).join(', '));
      return;
    }
    errEl.hidden = true;
    function done(){
      document.getElementById('ackEmail').textContent = val('sEmail');
      form.classList.add('hidden'); document.querySelector('.request-intro').style.display = 'none';
      document.getElementById('ack').hidden = false;
      document.getElementById('ack').scrollIntoView({behavior:'smooth', block:'center'});
    }
    if (val('sHpCheck')) { if (window.LYS_HS) LYS_HS.debug('support: hidden anti-spam field was filled, nothing sent'); done(); return; } // honeypot filled: likely a bot
    var urgent = document.getElementById('sUrgent').checked;
    // contact fields (0-1), then one ticket property (0-5) per website field
    var T = '0-5';
    var fields = [
      { name: 'firstname', value: val('sFirstName') },
      { name: 'lastname', value: val('sLastName') },
      { name: 'email', value: val('sEmail') },
      { name: 'company', value: val('sOrg') },
      { name: 'phone', value: val('sPhone') },
      { name: 'subject', value: (urgent ? 'URGENT: ' : '') + subjectLine(), objectTypeId: T },
      { name: 'content', value: val('sDesc'), objectTypeId: T },
      { name: 'hs_ticket_priority', value: urgent ? 'URGENT' : 'MEDIUM', objectTypeId: T },
      { name: 'preffer_contact', value: val('sContact'), objectTypeId: T },
      { name: 'preferred_callback_time', value: val('sCallback'), objectTypeId: T },
      { name: 'studyproject_in_dataportal', value: val('sProject'), objectTypeId: T },
      { name: 'button_model', value: val('sModel'), objectTypeId: T },
      { name: 'order_number', value: val('sOrder'), objectTypeId: T },
      { name: 'affected_buttons', value: val('sCount'), objectTypeId: T },
      { name: 'participant_ids', value: val('sPids'), objectTypeId: T },
      { name: 'phone_model', value: val('sPhoneModel'), objectTypeId: T },
      { name: 'operating', value: val('sOS'), objectTypeId: T },
      { name: 'app', value: val('sApp'), objectTypeId: T },
      { name: 'app_and_firmware_version', value: val('sAppVer'), objectTypeId: T },
      { name: 'issue_category', value: val('sCategory'), objectTypeId: T },
      { name: 'issue_started', value: val('sStarted'), objectTypeId: T },
      { name: 'last_successful_sync', value: val('sLastSync'), objectTypeId: T },
      { name: 'affected_date_range', value: val('sRange'), objectTypeId: T },
      { name: 'steps_already_tried', value: val('sTried'), objectTypeId: T },
      { name: 'selfhelp_checklist', value: checklistText(), objectTypeId: T }
    ];
    submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true');
    var send = window.LYS_HS ? window.LYS_HS.submit('support', fields) : Promise.resolve({ ok: false });
    send.then(function(res){
      submitBtn.disabled = false; submitBtn.removeAttribute('aria-busy');
      if (res.ok) { done(); return; }
      // DRAFT copy (Heidi to approve)
      errEl.innerHTML = 'Sorry, your request didn\'t go through. Please try again, or email it to <a href="mailto:hello@lystechnologies.io" style="text-decoration:underline;">hello@lystechnologies.io</a>.';
      errEl.hidden = false;
    });
  });

  // FAQ search + filter
  var search = document.getElementById('faqSearch');
  var faqs = document.querySelectorAll('.faq');
  var STOP = {wont:1, dont:1, doesnt:1, cant:1, isnt:1, not:1, my:1, the:1, a:1, an:1, is:1, it:1, its:1, to:1, i:1, how:1, do:1, does:1, why:1, what:1, can:1, and:1, or:1, of:1, in:1, on:1, with:1, our:1, we:1};
  function norm(q){ return q.toLowerCase().split(/\s+/).filter(Boolean).map(function(w){ w = w.replace(/[^a-z0-9%°-]/g,''); for (var k in SYN){ if (w.indexOf(k) === 0) return SYN[k]; } return w; }).filter(function(w){ return w.length > 1 && !STOP[w]; }); }
  function filterFaq(){
    var terms = norm(search.value); var shown = 0;
    faqs.forEach(function(f){
      var scope = f.getAttribute('data-scope');
      var okP = product === 'both' || scope === product || (product !== 'system' && (scope === 'both' || scope === 'system'));
      var text = f.getAttribute('data-text');
      var okQ = terms.every(function(t){ return text.indexOf(t) !== -1; });
      f.hidden = !(okP && okQ); if (!f.hidden) shown++;
      if (terms.length && !f.hidden) f.open = true; else if (!terms.length) f.open = false;
    });
    document.querySelectorAll('.faq-group').forEach(function(g){
      var vis = g.querySelectorAll('.faq:not([hidden])').length;
      g.hidden = vis === 0;
      g.querySelector('[data-count]').textContent = vis + (vis === 1 ? ' question' : ' questions');
      if (terms.length && vis) g.open = true; else if (!terms.length) g.open = false;
    });
    document.getElementById('faqEmpty').hidden = shown > 0;
    document.getElementById('faqStatus').textContent = (terms.length || product !== 'both') ? ('Showing ' + shown + ' of ' + faqs.length + ' questions' + (product !== 'both' ? ' for ' + ({v1:'Button V1', pro:'Button PRO', system:'Data Portal'}[product]) : '')) : 'Showing all questions. Open a topic to browse';
    var live = document.getElementById('faqLive');
    if (!terms.length) { live.hidden = true; live.innerHTML = ''; }
    else {
      var matches = [].filter.call(faqs, function(f){ return !f.hidden; });
      live.innerHTML = '';
      var head = document.createElement('div'); head.className = 'fl-head mono';
      head.textContent = matches.length ? (matches.length + (matches.length === 1 ? ' matching question' : ' matching questions')) : 'No matching questions';
      live.appendChild(head);
      matches.slice(0, 6).forEach(function(f){
        var b = document.createElement('button'); b.type = 'button'; b.className = 'fl-item'; b.setAttribute('role','option');
        b.textContent = f.querySelector('.faq-q').textContent;
        b.addEventListener('click', function(){ live.hidden = true; var g = f.closest('.faq-group'); if (g) g.open = true; f.open = true; f.scrollIntoView({behavior:'smooth', block:'center'}); });
        live.appendChild(b);
      });
      var all = document.createElement('button'); all.type = 'button'; all.className = 'fl-all';
      all.textContent = matches.length ? 'Show all results in the FAQ ↓' : 'Ask us directly →';
      all.addEventListener('click', function(){ live.hidden = true; document.getElementById(matches.length ? 'faq' : 'request') ? (matches.length ? document.getElementById('faq').scrollIntoView({behavior:'smooth', block:'start'}) : document.getElementById('faqEmptyAsk').click()) : null; });
      live.appendChild(all);
      live.hidden = false;
    }
  }
  var tmr; search.addEventListener('input', function(){ clearTimeout(tmr); tmr = setTimeout(filterFaq, 220); });

  // deep-link pre-fill (future in-app "Diagnose and get help" flow):
  // /pages/support?model=PRO&count=3&project=ABC&app=Collect&appver=2.4.1&fw=1.8&phone=Pixel%208&os=Android%2014&lastsync=2%20Sept%2018:30&category=syncing
  var qp = new URLSearchParams(location.search);
  if (qp.has('model') || qp.has('project')) {
    var m = (qp.get('model') || '').toUpperCase();
    if (m.indexOf('PRO') !== -1) document.getElementById('sModel').value = 'Button PRO';
    else if (m) document.getElementById('sModel').value = 'Button V1';
    var map = {order:'sOrder', count:'sCount', project:'sProject', appver:'sAppVer', phone:'sPhoneModel', os:'sOS', lastsync:'sLastSync'};
    for (var k in map) if (qp.get(k)) document.getElementById(map[k]).value = qp.get(k);
    if (qp.get('fw')) document.getElementById('sAppVer').value = (qp.get('appver') || '') + ' · fw ' + qp.get('fw');
    if (qp.get('app')) document.getElementById('sApp').value = /track/i.test(qp.get('app')) ? 'LYS Track' : 'LYS Collect';
    if (qp.get('category') && CATEGORY[qp.get('category')]) { symptom = qp.get('category'); document.getElementById('sCategory').value = CATEGORY[symptom]; }
    openRequest();
  }
})();
} catch (e) { console.error("lys-v4 support", e); }
